/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_PopularInputs */

const en_landing_pricing_popular = /** @type {(inputs: Landing_Pricing_PopularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Popular`)
};

const zh_landing_pricing_popular = /** @type {(inputs: Landing_Pricing_PopularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`热门`)
};

/**
* | output |
* | --- |
* | "Popular" |
*
* @param {Landing_Pricing_PopularInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_popular = /** @type {((inputs?: Landing_Pricing_PopularInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_PopularInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_popular(inputs)
	return zh_landing_pricing_popular(inputs)
});
export { landing_pricing_popular as "landing.pricing.popular" }